var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfigurations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6053 10.0262C13.6439 9.69206 13.6629 9.34962 13.6629 9.00002C13.6629 8.65042 13.6439 8.30798 13.6053 7.97385L15.1588 6.7748C15.2746 6.68621 15.3079 6.52156 15.2376 6.38936L13.8582 3.78508C13.7879 3.65288 13.6286 3.59638 13.4865 3.6457L11.6872 4.2564C11.2568 3.91284 10.7777 3.62739 10.2615 3.41241L10.0453 1.54618C10.0268 1.39755 9.90037 1.28571 9.75003 1.28571H6.24997C6.09963 1.28571 5.97318 1.39755 5.95468 1.54618L5.73851 3.41241C5.2223 3.62739 4.74325 3.91284 4.31281 4.2564L2.51348 3.6457C2.37142 3.59638 2.21212 3.65288 2.14181 3.78508L0.762408 6.38936C0.692095 6.52156 0.725367 6.68621 0.841204 6.7748L2.39469 7.97385C2.35615 8.30798 2.3371 8.65042 2.3371 9.00002C2.3371 9.34962 2.35615 9.69206 2.39469 10.0262L0.841204 11.2253C0.725367 11.3138 0.692095 11.4784 0.762408 11.6106L2.14181 14.2149C2.21212 14.3471 2.37142 14.4036 2.51348 14.3543L4.31281 13.7436C4.74325 14.0872 5.2223 14.3726 5.73851 14.5876L5.95468 16.4539C5.97318 16.6025 6.09963 16.7143 6.24997 16.7143H9.75003C9.90037 16.7143 10.0268 16.6025 10.0453 16.4539L10.2615 14.5876C10.7777 14.3726 11.2568 14.0872 11.6872 13.7436L13.4865 14.3543C13.6286 14.4036 13.7879 14.3471 13.8582 14.2149L15.2376 11.6106C15.3079 11.4784 15.2746 11.3138 15.1588 11.2253L13.6053 10.0262Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 9,
    r: 1.6,
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigurations);
export default __webpack_public_path__ + "static/media/configurations.1cabd1fb2c5bb75de6e6269dcdd6ecd8.svg";
export { ForwardRef as ReactComponent };